import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VehiculoFormComponent } from '../components/vehiculo-form/vehiculo-form.component';
import { AuthService } from '../CookieAuth/auth.service';
import { Vehiculo } from '../interfaces/vehiculo';
import { TestService } from '../service/test.service';
import {VehiculoService} from '../service/vehiculo.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public vehiculos?: any[];
  cosa?:any[];
  constructor(private vehiculoService: VehiculoService,private cookie: AuthService, private test: TestService, private dialog: MatDialog) {

   }

  ngOnInit() {
    console.log("segun cokie"+this.cookie.checkExistCookie());
    this.cookie.checkExistCookie().then((data:boolean) => {
      if (data) {
        this.vehiculoService.getVehiculos().subscribe((data:Vehiculo[])=>{
          console.log(data);
          this.vehiculos = data;
        });
      } else {
        //Hacer el maldito redirect....
        // console.log("home devuelve")
        window.location.href = "/";

      }
    })

    // this.test.get().subscribe((data) => {
    //   this.cosa=data;
    //   console.log(this.cosa);
    // });



  }

  modificarVehiculo(id:number)
  {
    let dialogRef = this.dialog.open(VehiculoFormComponent, {
      data: {id: id},
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      this.vehiculoService.getVehiculos().subscribe((data:Vehiculo[])=>{
        console.log(data);
        this.vehiculos = data;
      });

    });

    console.log(id);
  }

}
